import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://nexuscatalystagency.com").replace(/\/$/, "");

const setMeta = (attr, key, content) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const useSEO = (title, description, options = {}) => {
  const { pathname } = useLocation();
  const { noindex = false, ogType = "website" } = options;
  useEffect(() => {
    const url = `${SITE_URL}${pathname}`;
    document.title = title;
    if (description) setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", title);
    if (description) setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", ogType);
    setMeta("property", "og:site_name", "Nexus Catalyst Agency");
    setMeta("property", "og:image", `${SITE_URL}/assets/nexus-logo-bg.png`);
    setMeta("property", "og:locale", "en_IN");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    if (description) setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", `${SITE_URL}/assets/nexus-logo-bg.png`);
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }, [title, description, pathname, noindex, ogType]);
};
